"use client";
import { useState } from "react";
import { useApp } from "./provider";

export function AslThumbnail({
  src,
  label,
  className,
}: {
  src?: string;
  label: string;
  className?: string;
}) {
  const { t } = useApp();
  const [failed, setFailed] = useState(false);
  return src && !failed ? (
    <img
      src={src}
      alt={label}
      className={className}
      loading="lazy"
      decoding="async"
      onError={() => setFailed(true)}
    />
  ) : (
    <span
      className={className}
      role="img"
      aria-label={label}
      style={{
        display: "grid",
        placeItems: "center",
        padding: 12,
        textAlign: "center",
        background: "#e9e5f7",
        color: "#4e4478",
      }}
    >
      {t("Preview unavailable · Open to play", "预览不可用 · 打开播放")}
    </span>
  );
}
